var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "1400" },
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _vm.vehicle
        ? _c(
            "v-row",
            { staticClass: "mx-0" },
            [
              _c(
                "v-col",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { short: "", dark: "", color: "primary" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: { click: _vm.close }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                          _c("v-toolbar-title", [
                            _c("span", [
                              _vm._v("Vehicle " + _vm._s(_vm.vehicle.id))
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-tabs",
                            {
                              attrs: {
                                "fixed-tabs": "",
                                "background-color": "indigo",
                                dark: ""
                              },
                              model: {
                                value: _vm.tab,
                                callback: function($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab"
                              }
                            },
                            [
                              _c("v-tab", { attrs: { href: "#tab-details" } }, [
                                _vm._v(" Details ")
                              ]),
                              _c(
                                "v-tab",
                                { attrs: { href: "#tab-memberships" } },
                                [_vm._v(" Fleet Memberships ")]
                              ),
                              _c(
                                "v-tab",
                                { attrs: { href: "#tab-attributes" } },
                                [_vm._v(" Attributes ")]
                              ),
                              _c(
                                "v-tab",
                                { attrs: { href: "#tab-properties" } },
                                [_vm._v(" Properties ")]
                              ),
                              _c(
                                "v-tab",
                                { attrs: { href: "#tab-reported-properties" } },
                                [_vm._v(" Reported Properties ")]
                              ),
                              _c(
                                "v-tab",
                                { attrs: { href: "#tab-installations" } },
                                [_vm._v(" Installations ")]
                              ),
                              _c("v-tab", { attrs: { href: "#tab-tariffs" } }, [
                                _vm._v(" Tariffs ")
                              ]),
                              _c("v-tab", { attrs: { href: "#tab-logs" } }, [
                                _vm._v(" Logs ")
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-tabs-items",
                            {
                              model: {
                                value: _vm.tab,
                                callback: function($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab"
                              }
                            },
                            [
                              _c(
                                "v-tab-item",
                                { key: 1, attrs: { value: "tab-details" } },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Vehicle Info")
                                      ]),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "VehicleBasicInfoForm",
                                            {
                                              attrs: {
                                                vehicle: _vm.vehicle,
                                                editable: true
                                              },
                                              on: { save: _vm.saveVehicleInfo }
                                            },
                                            [_vm._v("> ")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card",
                                    [
                                      _c("v-card-title", [
                                        _vm._v("Contact Information")
                                      ]),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("ContactInformationForm", {
                                            attrs: {
                                              contactInformation:
                                                _vm.vehicle.contactInformation,
                                              editable: true
                                            },
                                            on: {
                                              save: _vm.saveContactInformation
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                { key: 2, attrs: { value: "tab-memberships" } },
                                [
                                  _c("VehicleFleetMembershipsForm", {
                                    attrs: { vehicle: _vm.vehicle },
                                    on: {
                                      addFleetMembership:
                                        _vm.addFleetMembership,
                                      saveFleetMembership:
                                        _vm.saveFleetMembership,
                                      deleteFleetMembership:
                                        _vm.deleteFleetMembership
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                { key: 3, attrs: { value: "tab-attributes" } },
                                [
                                  _c("VehicleAttributesForm", {
                                    attrs: { vehicle: _vm.vehicle },
                                    on: {
                                      addNewAttribute: _vm.addNewAttribute,
                                      saveAttribute: _vm.saveAttribute,
                                      deleteAttribute: _vm.deleteAttribute
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                { key: 4, attrs: { value: "tab-properties" } },
                                [
                                  _c("VehiclePropertiesForm", {
                                    attrs: { vehicle: _vm.vehicle },
                                    on: {
                                      addNewProperty: _vm.addNewProperty,
                                      saveProperty: _vm.saveProperty,
                                      deleteProperty: _vm.deleteProperty
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                {
                                  key: 7,
                                  attrs: { value: "tab-reported-properties" }
                                },
                                [
                                  _c("PropertiesTable", {
                                    attrs: {
                                      properties:
                                        _vm.vehicle.reportedProperties,
                                      canCreate: false,
                                      canEdit: false
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                {
                                  key: 5,
                                  attrs: { value: "tab-installations" }
                                },
                                [
                                  _c("VehicleInstallationsView", {
                                    attrs: {
                                      installations: _vm.vehicle.installations
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                { key: 6, attrs: { value: "tab-tariffs" } },
                                [
                                  _c("VehicleTariffsForm", {
                                    attrs: { vehicle: _vm.vehicle },
                                    on: {
                                      addNewTariffImport:
                                        _vm.addNewTariffImport,
                                      saveTariffImport: _vm.saveTariffImport,
                                      saveTariffId: _vm.saveTariffId,
                                      deleteTariffImport: _vm.deleteTariffImport
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                { key: 8, attrs: { value: "tab-logs" } },
                                [
                                  _c("VehicleLogsView", {
                                    attrs: { vehicleId: _vm.vehicle.id }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }